// extracted by mini-css-extract-plugin
export default {"containerFinca":"finca_containerFinca__lt2v7"};